
import classes from './Video.module.scss' ;

function Video({vSrc,vTitle ,vContent,vHeader}) {
    return (
        <section className={`${classes["section__container"]} `}>
        <p className={classes["section__subheader"]}>{vHeader}</p>
        <p className={classes["__strong"]}>
            {vContent}
        </p>
        <div className={`${classes["container"]} `}>
            <iframe 
                width="937" height="400" src={vSrc}
                title={vTitle}
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
            </iframe>
        </div>
    </section>
    )
}

export default Video
